import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { ContactsOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  contactModulesList,
  ContactSubModuleDefinition,
} from 'enums/modulesDefinition';

const { SubMenu } = Menu;

export const ContactMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case ContactSubModuleDefinition.representativesList:
        return (
          <Menu.Item
            key={MenuIndexes.REPRESENTATIVES_LIST}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/representatives">{el.title}</Link>
          </Menu.Item>
        );
      case ContactSubModuleDefinition.representativesAdd:
        return (
          <Menu.Item
            key={MenuIndexes.REPRESENTATIVES_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/representatives/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContactSubModuleDefinition.dataProtection:
        return (
          <Menu.Item
            key={MenuIndexes.DATA_PROTECTION}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/data-protection">{el.title}</Link>
          </Menu.Item>
        );
      case ContactSubModuleDefinition.distribution:
        return (
          <Menu.Item
            key={MenuIndexes.DISTRIBUTION_LIST}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/distribution">{el.title}</Link>
          </Menu.Item>
        );
      case ContactSubModuleDefinition.distributionAdd:
        return (
          <Menu.Item
            key={MenuIndexes.DISTRIBUTION_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/distribution/add">{el.title}</Link>
          </Menu.Item>
        );
      case ContactSubModuleDefinition.privacy:
        return (
          <Menu.Item
            key={MenuIndexes.PRIVACY}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/privacy">{el.title}</Link>
          </Menu.Item>
        );
      case ContactSubModuleDefinition.rules:
        return (
          <Menu.Item
            key={MenuIndexes.RULES}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/rules">{el.title}</Link>
          </Menu.Item>
        );
      case ContactSubModuleDefinition.serviceMap:
        return (
          <Menu.Item
            key={MenuIndexes.SERVICE_MAP}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/service-map">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = contactModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <SubMenu
      key={SubMenuIndexes.CONTACT}
      icon={<ContactsOutlined />}
      title={title}
      onTitleClick={(e) => subMenuClick(e)}
    >
      {checkPermissions.map((module) => renderSubModules(module))}
    </SubMenu>
  );
};
